/*
 * Rennsieger — canonical model slider (filter + UX).
 *
 * ONE component, shared by every "Shop by model" slider: headlights, DRL, and
 * (when it goes live) taillights. Any section that emits the canonical markup
 *   [data-rsg-models] > [data-rsg-modelslider] (chips) + [data-rsg-modelgrid] (items)
 * inherits BOTH behaviours below, with no per-section script:
 *
 *   1. Filter  — clicking a [data-model-chip] show/hides [data-model] grid items.
 *                Pure show/hide; the grid is server-rendered, nothing to fetch.
 *   2. Slider UX — click-and-drag to scroll (mouse), a reveal-more nudge when a
 *                mid-row chip is picked, and an optional right-edge chevron
 *                ([data-rsg-mslider-nav], a sibling of the slider) that jumps to
 *                the end, then flips to jump back. Hidden when the row fits.
 *
 * No dependencies. No-ops when its markup is absent. Idempotent across
 * shopify:section:load.
 */
(function () {
  'use strict';

  function initModels(root) {
    if (root.dataset.rsgModelsBound === '1') return;
    root.dataset.rsgModelsBound = '1';

    var slider = root.querySelector('[data-rsg-modelslider]');
    var grid = root.querySelector('[data-rsg-modelgrid]');
    if (!slider || !grid) return;

    var chips = Array.prototype.slice.call(slider.querySelectorAll('[data-model-chip]'));
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-model]'));

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var model = chip.getAttribute('data-model-chip');

        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        items.forEach(function (item) {
          var show = model === '__all__' || item.getAttribute('data-model') === model;
          item.classList.toggle('is-hidden', !show);
        });
      });
    });

    initSliderUX(slider);
  }

  /* Drag-to-scroll + reveal-nudge + chevron. Canonical: runs on any
     [data-rsg-modelslider]. Guarded so it binds once per slider. */
  function initSliderUX(s) {
    if (s.dataset.rsgSliderUx === '1') return;
    s.dataset.rsgSliderUx = '1';

    /* Click-and-drag to scroll (mouse). Touch + trackpad already scroll natively. */
    var down = false, startX = 0, startScroll = 0, moved = false;
    s.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startScroll = s.scrollLeft;
      s.classList.add('is-grabbing');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      s.scrollLeft = startScroll - dx;
    });
    window.addEventListener('pointerup', function () {
      if (down) { down = false; s.classList.remove('is-grabbing'); }
    });
    /* swallow the click that ends a drag so a chip isn't toggled by accident */
    s.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    /* Reveal-more nudge: selecting a chip sitting in the middle band (30-70% of the
       viewport) eases it toward the left so the chips after it come into view — a light,
       standard "there's more this way" cue. Chips already near an edge are left alone. */
    s.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-model-chip]');
      if (!chip || moved) return;
      var vw = s.clientWidth;
      var center = (chip.offsetLeft - s.scrollLeft) + chip.offsetWidth / 2;
      var ratio = center / vw;
      if (ratio < 0.30 || ratio > 0.70) return;
      var target = chip.offsetLeft - vw * 0.26;           // land its left edge ~26% in
      var max = s.scrollWidth - vw;
      target = Math.max(0, Math.min(target, max));
      s.scrollTo({ left: target, behavior: 'smooth' });
    });

    /* Right-edge chevron control. ">" jumps to the end in one click; there it flips to "<" and
       jumps back to the start. Hidden when the row doesn't overflow. */
    var nav = s.parentNode.querySelector('[data-rsg-mslider-nav]');
    if (nav) {
      var atEnd = function () { return s.scrollLeft >= (s.scrollWidth - s.clientWidth - 4); };
      var sync = function () {
        if (s.scrollWidth <= s.clientWidth + 4) { nav.hidden = true; return; }
        nav.hidden = false;
        var back = atEnd();
        nav.classList.toggle('is-back', back);
        nav.setAttribute('aria-label', back ? 'Back to start' : 'Scroll models right');
      };
      nav.addEventListener('click', function () {
        var max = s.scrollWidth - s.clientWidth;
        s.scrollTo({ left: atEnd() ? 0 : max, behavior: 'smooth' });
      });
      s.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
      setTimeout(sync, 400);
    }
  }

  function boot() {
    document.querySelectorAll('[data-rsg-models]').forEach(initModels);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
